import { render } from "./StatsBuilderSubCol.vue?vue&type=template&id=68fb6674"
import script from "./StatsBuilderSubCol.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderSubCol.vue?vue&type=script&lang=ts"

import "./StatsBuilderSubCol.vue?vue&type=style&index=0&id=68fb6674&lang=scss"
script.render = render

export default script